export const landingPageData = {
  hero: {
    title: "Carolyn Godschild Miller, Ph.D.",
    subtitle: "Author, Psychologist & Spiritual Teacher",
    description: "Exploring miracles, soulmates, and spiritual awakening through the lens of psychology and A Course in Miracles",
    ctaText: "Explore Books",
    ctaSecondary: "Read Blog",
    backgroundImage: "https://images.unsplash.com/photo-1506126613408-eca07ce68773",
    authorPhoto: "https://customer-assets.emergentagent.com/job_acimi-portal/artifacts/3wn3i3gz_6J2A9749.jpeg",
    authorPhotoWithArnold: "https://customer-assets.emergentagent.com/job_acimi-portal/artifacts/9029l02n_Picture1.jpg",
    carmelaPhoto: "/carmela_corallo.jpg"
  },

  featuredBook: {
    title: "SELF-HEALING",
    subtitle: "THE SCIENCE, PSYCHOLOGY AND MYSTICISM OF HEALING MIRACLES",
    description: `Self-Healing begins with an optional Introduction for Skeptics, to reacquaint science-minded readers with the findings in quantum theory which verify that supernatural phenomena occur constantly, mind effects matter, and allow for the possibility that a more skillful use of one's consciousness, can change what manifests in one's body and world. The first and second chapters present my reasons for thinking that "spontaneous remissions" are better thought of as "miracles," and that there is a perspective common to the mystical teachings of all major religions, that assumes the existence of a quantum-mechanical universe. Subsequent chapters present fascinating, true stories of miraculous healings, and are used to illustrate the way particular changes of mind and belief, transform the body. I present two ways to heal consistent with quantum mechanics, and allow readers to try their knowledge out on three additional cases.

My operational definition of miracles is: "Instances where a 'bad' situation, that seemed to have little, or no likelihood of a 'good' outcome by any ordinary means, astonishes us by turning out well." The book demonstrates how those who achieve miracles/spontaneous remissions do the things mystics regard as essential.`
  },

  appendicesInfo: {
    title: "Appendices & Supplementary Materials",
    subtitle: "Deep Dive into Spiritual Wisdom",
    description: "Explore comprehensive appendices covering Dr. Miller's professional background, relationship with Jesus, guide to the Hindu Chakra system, A Course in Miracles history, and previous publications.",
    ctaText: "View All Appendices"
  },
  
  about: {
    title: "About Carolyn",
    tagline: "Psychologist, Author & Spiritual Guide",
    opening: "I've experienced miracles personally, and am convinced that while they are presently rare, they will become much more accessible as people discover how to make them possible. Readers will be able to try out their understanding of the two methods I present for creating miracles and determine for themselves whether what I'm saying is true.",
    autobiography: {
      title: "Autobiography",
      content: `After receiving an undergraduate degree in Philosophy in 1968, in 1978 I completed a doctorate in experimental psychology, with specialization in the Neurophysiology of Motivation and Emotion. My doctoral research was funded by a Two-Year, Predoctoral Research Support Fellowship from the National Institute of Mental Health, that I'd won in competition with graduate students from throughout the U.S. I was elected to membership in Sigma Xi, The Scientific Research Honors Society in 1977.

I began teaching psychology at the graduate level in 1978, and by 1984, had also become a licensed clinical psychologist in independent practice in California. I taught for more than 15 years, supervising dissertations and theses on a wide variety of psychological topics.

Along the way, I behaviorally treated "hyperactive" preschoolers, directed a psychotherapy program for hospitalized female mental patients diagnosed with borderline personality disorder; performed psychological testing on institutionalized adolescents, trained volunteers in supporting People With AIDS; and volunteered as an instructor in interviewing techniques, for medical students at UCLA's David Geffen School of Medicine. My husband, Arnold S. Weiss, Ph.D. and I were founding members of The Foundation and Institute for the Study of "A Course in Miracles," set up to provide education, and psychotherapy of the type recommended in that volume.

In addition to my professional articles and papers, I've conventionally published two previous books on life-saving miracles in cases of assaults and accidents, collaborated with colleagues on a Sense of Humor Test, and published two others, on soulmate relationships and divine guidance, respectively. The first Creating Miracles was translated into Spanish, Portuguese and Dutch, and was selected a choice people offered on the Paperback Book of the Month Club.`
    },
    spiritualEducation: {
      title: "My Spiritual Education",
      content: `Raised Christian, I was a confirmed atheist by my teens, and was thoroughly educated in materialist atheism throughout my academic training. Around 1982 I sought personal instruction from an enlightened, miracle-working teacher of Siddha Yoga, named Carmela Corallo. The education she provided in Hindu mysticism, miracles, intuition, and the transmission of Shaktipat Kundalini, led me, perhaps ironically, to a personal relationship with Jesus Christ, and to proficiency in channeling Shaktipat Kundalini to heal and uplift others. I have performed miracles and been rescued from what looked like certain death, by them.

Nor are miracles of healing of purely academic interest to me. I was diagnosed with stage 4, splenic lymphoma in 2018, and end-stage cirrhosis of the liver, a month or so later. The cancer was quickly put into remission through immune therapy, and while still showing evidence of cirrhosis, my liver is presently functioning at the edge of the normal range. I also have a slow-growing, malignant endocrine tumor in my ileum, but my oncologist keeps it plugged up with a monthly shot, and subsequent to finding that solution, it hasn't bothered me at all.

I believe that I developed these deadly medical conditions, as a result of my grief about the 2014 death of my husband, and my distress over the political and social divisions tearing the United States apart. I had true ill-will toward the people I held responsible for that! But, through recognizing my spiritual error and forgiving, I've been able to benefit from the wonderful, state-of-the art medical care I've received from outstanding physicians. My present good health may not be miraculous, but it does represent evidence that getting our minds back into alignment with spiritual truth, heals the body.`
    },
    highlights: [
      {
        number: "40+",
        label: "Years Teaching"
      },
      {
        number: "5",
        label: "Published Books"
      },
      {
        number: "NIMH",
        label: "Research Fellow"
      }
    ]
  },

  featuredBook: {
    title: "SELF-HEALING",
    subtitle: "THE SCIENCE, PSYCHOLOGY AND MYSTICISM OF HEALING MIRACLES",
    description: `Self-Healing begins with an optional Introduction for Skeptics, to reacquaint science-minded readers with the findings in quantum theory which verify that supernatural phenomena occur constantly, mind effects matter, and allow for the possibility that a more skillful use of one's consciousness, can change what manifests in one's body and world. The first and second chapters present my reasons for thinking that "spontaneous remissions" are better thought of as "miracles," and that there is a perspective common to the mystical teachings of all major religions, that assumes the existence of a quantum-mechanical universe. Subsequent chapters present fascinating, true stories of miraculous healings, and are used to illustrate the way particular changes of mind and belief, transform the body. I present two ways to heal consistent with quantum mechanics, and allow readers to try their knowledge out on three additional cases.

My operational definition of miracles is: "Instances where a 'bad' situation, that seemed to have little, or no likelihood of a 'good' outcome by any ordinary means, astonishes us by turning out well." The book demonstrates how those who achieve miracles/spontaneous remissions do the things mystics regard as essential.`
  },

  books: [
    {
      id: 1,
      title: "Creating Miracles",
      subtitle: "Understanding the Experience of Divine Intervention",
      author: "Carolyn G. Miller, Ph.D.",
      description: "A scientist as well as a student of metaphysics, Dr. Carolyn Miller has spent more than twenty-five years researching the elements that are common in real-life miracles. She has discovered that ordinary people often survive impending disaster by entering a serene state of consciousness and following inner guidance.",
      coverImage: "https://m.media-amazon.com/images/I/418UWOTeGPL._SY445_SX342_.jpg",
      amazonLink: "https://www.amazon.com/Creating-Miracles-Practical-Divine-Intervention-ebook/dp/B004OEKGUC",
      price: "$9.59",
      rating: 4.0,
      reviews: 32,
      highlights: [
        "25+ years of miracle research",
        "Backed by scientific methodology",
        "Practical techniques for miracle-readiness",
        "Real-life survival stories"
      ],
      formats: ["Kindle $9.59", "Paperback $6.43"]
    },
    {
      id: 2,
      title: "Soulmates",
      subtitle: "Following Inner Guidance to the Relationship of Your Dreams",
      author: "Carolyn Godschild Miller",
      description: "In her lively and conversational style, Carolyn Miller takes a high-spirited, unsentimental, in-depth look at what a soulmate is and how to connect with that special person. Sharing her own quest and that of dozens of other couples for a meant-to-be relationship.",
      coverImage: "https://m.media-amazon.com/images/I/61ochSiUcdL._SY522_.jpg",
      amazonLink: "https://www.amazon.com/Soulmates-Following-Guidance-Relationship-Dreams-ebook/dp/B004CYF39I",
      price: "$12.99",
      rating: 4.2,
      reviews: 43,
      highlights: [
        "True stories of soulmate connections",
        "Inner guidance techniques",
        "Practical relationship advice",
        "Endorsed by bestselling authors"
      ],
      formats: ["Kindle $12.99", "Paperback $16.64"]
    },
    {
      id: 3,
      title: "Conversations with Jesus",
      subtitle: "Concerning Awakening",
      author: "Carolyn Godschild Miller, Ph.D.",
      description: "Generously endorsed by bestselling authors Gary Renard and Marianne Williamson, Conversations documents Miller's spiritual awakening under the mentorship of an enlightened teacher of Siddha Yoga, and Jesus' A Course in Miracles. A miracle literally saved her life, and Jesus' guidance taught her to heal.",
      coverImage: "https://aciminla.com/LinkClick.aspx?fileticket=An0evmrFfOs%253d&portalid=8",
      amazonLink: "https://aciminla.com/",
      price: "Available Now",
      rating: 5.0,
      reviews: 0,
      highlights: [
        "Personal stories of miracles",
        "Divine guidance experiences",
        "Path to enlightenment",
        "Endorsed by Gary Renard & Marianne Williamson"
      ],
      formats: ["Paperback", "Hardcover"]
    }
  ],

  testimonials: [
    {
      id: 1,
      book: "Creating Miracles",
      name: "Marianne Williamson",
      role: "Bestselling Author",
      text: "Carolyn Miller provides compelling reasons to believe in divine intervention, as well as step-by-step instructions for making the mind more miracle-ready. Creating Miracles is a gift.",
      rating: 5
    },
    {
      id: 2,
      book: "Soulmates",
      name: "Amazon Reader",
      role: "Verified Purchase",
      text: "This is the top 'soulmate' book I have read to date and the only one I will actually recommend. It brought me to the realization to trust that if there is a relationship that is meant to be, spirit has the capability of bringing it together.",
      rating: 5
    },
    {
      id: 3,
      book: "Soulmates",
      name: "Stephan A. Schwartz",
      role: "Reader",
      text: "This is not an author talking down to her readers, nor a guru making pronouncements. This is a middle aged woman, therapist, and college professor, who worked hard for her insights, and who knows others are working hard as well.",
      rating: 4
    }
  ],

  blogPosts: [
    {
      id: 1,
      title: "The Simplicity of the Holy Relationship",
      date: "August 9, 2014",
      excerpt: "As a student of A Course in Miracles for some 30 years, I've devoted a good deal of effort to understanding the 'Holy Relationship.' Although I once thought of it as a pretty advanced, and somewhat mysterious step in the process the Course recommends for achieving salvation, I now see how simple it really is...",
      link: "https://godschild990.blogspot.com/2014/08/the-simplicity-of-holy-relationship-by.html"
    }
  ],

  faq: [
    {
      question: "Where can I purchase Carolyn's books?",
      answer: "All of Carolyn's books are available on Amazon in both Kindle and paperback formats. Click on any book above to be directed to its Amazon page where you can purchase or read a free sample."
    },
    {
      question: "What is A Course in Miracles?",
      answer: "A Course in Miracles is a self-study spiritual thought system that teaches the way to universal love and peace through undoing guilt by forgiving others. Dr. Miller's work extensively draws from and interprets the Course's principles."
    },
    {
      question: "Are the books suitable for beginners?",
      answer: "Absolutely! While Dr. Miller's books are deeply rooted in spiritual principles, they are written in an accessible, conversational style with real-life stories that make complex concepts understandable for readers at any level of spiritual practice."
    },
    {
      question: "Does Dr. Miller offer consultations or speaking engagements?",
      answer: "For inquiries about consultations, speaking engagements, or other professional services, please use the contact form below. Dr. Miller will respond to all genuine inquiries."
    },
    {
      question: "How can I stay updated on new releases?",
      answer: "You can follow Dr. Miller's blog at godschild990.blogspot.com for regular updates, insights, and announcements about new publications. You can also follow her Amazon author page."
    },
    {
      question: "What makes Dr. Miller's approach unique?",
      answer: "Dr. Miller uniquely combines her scientific training as an experimental psychologist with deep spiritual practice. Her work bridges the gap between psychology and spirituality, offering evidence-based insights into miracles, relationships, and awakening."
    }
  ],

  contact: {
    title: "Get in Touch",
    subtitle: "Have questions about the books or interested in speaking engagements? Send a message below.",
    email: "aciminla@gmail.com",
    address: "Los Angeles, California",
    blog: "https://godschild990.blogspot.com/"
  },

  shareYourMiracle: {
    title: "Share Your Miracle",
    subtitle: "Have you experienced a miracle in your life?",
    description: "Dr. Miller is collecting true stories of miracles for future research and publications. Your story could inspire others and contribute to understanding how miracles work. All submissions are kept confidential unless you give permission to share.",
    ctaText: "Share Your Story"
  }
};
